module.exports = __webpack_public_path__ + "public/img/new_certificate_back.199041ec.png";